module.exports.fromTo = require('./lib/from-to');
module.exports.invertDictionary = require('./lib/invert-dictionary');
module.exports.generateDictionaryFromKeys = require('./lib/generate-dictionary-from-keys');
module.exports.fromToKey = require('./lib/from-to-key');
